import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { Box, Flex } from 'rebass/styled-components';
import MediaQuery from '../../../utils/mediaQuery';
import { componentMapping } from '../../../utils/helpers';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const MobilePeekWrapper = styled(Flex)`
  width: 100%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  gap: 1rem;
  align-items: stretch;

  ${MediaQuery.large`
    display: none;
  `}
`;

const LeftSpacer = styled(Box)`
  flex: 0 0 8%;
`;

const MobileCardWrapper = styled(Box)`
  flex: 0 0 78%;

  & > * {
    width: 100%;
  }
`;

const SkeletonPeek = styled(Box)`
  flex: 1;
  background-color: #e0e0e0;
  border-radius: 8px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

const DesktopWrapper = styled(Flex)`
  display: none;
  width: 100%;
  gap: 1.5rem;

  ${MediaQuery.large`
    display: flex;
  `}
`;

const DesktopCardWrapper = styled(Flex)`
  flex: 1;
  padding-top: 2.75rem;
`;

const PromoCardSkeleton = ({
  columns,
  page,
  groupRowTitle = '',
  restrictContent = true,
}) => {
  const cardCount = columns.length;
  const limitedColumns = columns.slice(0, 3);
  const showMobilePeek = cardCount > 1;

  const renderPromoCard = item => {
    const Template = componentMapping[item.identifier];
    if (!Template) return null;
    return (
      <Template
        {...item}
        page={page}
        columnsLength={cardCount}
        groupRowTitle={groupRowTitle}
        restrictContent={restrictContent}
      />
    );
  };

  return (
    <>
      <MobilePeekWrapper>
        {showMobilePeek && <LeftSpacer />}
        <MobileCardWrapper sx={{ flex: showMobilePeek ? '0 0 78%' : '1' }}>
          {renderPromoCard(columns[0])}
        </MobileCardWrapper>
        {showMobilePeek && <SkeletonPeek />}
      </MobilePeekWrapper>

      <DesktopWrapper>
        {limitedColumns.map(item => (
          <DesktopCardWrapper key={item.id}>
            {renderPromoCard(item)}
          </DesktopCardWrapper>
        ))}
      </DesktopWrapper>
    </>
  );
};

PromoCardSkeleton.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  page: PropTypes.object.isRequired,
  groupRowTitle: PropTypes.string,
  restrictContent: PropTypes.bool,
};

export default PromoCardSkeleton;
